import {
  GET_PROPERTIES,
  GET_PROPERTIES_SUCCESS,
  GET_PROPERTIES_FAILURE,
  GET_PROPERTY,
  GET_PROPERTY_SUCCESS,
  GET_PROPERTY_FAILURE,
} from './constants';

// Get Properties
export const getProperties = () => ({
  type: GET_PROPERTIES,
  payload: { },
});

export const getPropertiesSuccess = (properties) => ({
  type: GET_PROPERTIES_SUCCESS,
  payload: properties,
});

export const getPropertiesFailure = (error) => ({
  type: GET_PROPERTIES_FAILURE,
  payload: { message: error },
});

// Get Property
export const getProperty = (propertyId) => ({
  type: GET_PROPERTY,
  payload: { propertyId },
});

export const getPropertySuccess = (property) => ({
  type: GET_PROPERTY_SUCCESS,
  payload: property,
});

export const getPropertyFailure = (error) => ({
  type: GET_PROPERTY_FAILURE,
  payload: { message: error },
});
